import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Formatter from '../../utils/Formatter';

const FinancesAndEmployment = ({ analysisContext: { finances, employment }}) => {

    return (
        <div className='row'>
            <div className='col-12'>
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className='text-center'>
                                    Individual Gross Income
                                </TableCell>
                                <TableCell className='text-center'>
                                    Tax Filing
                                </TableCell>
                                <TableCell className='text-center'>
                                    Total dependants
                                </TableCell>
                                <TableCell className='text-center'>
                                    Months worked for Non-profit
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell className='text-center'>
                                    {finances ? `$ ${Formatter.money(finances.agi)}` : 'unknown'}
                                </TableCell>
                                <TableCell className="text-center">
                                    {finances ? `${finances.status}` : 'unknown'}
                                </TableCell>
                                <TableCell className='text-center'>
                                    {finances ? `${finances.dependants}` : 'unknown'}
                                </TableCell>
                                <TableCell className="text-center">
                                    {employment ? `${employment.payments}` : 'unknown'}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        </div>
    )
}

export default FinancesAndEmployment;
